export const environment = {
    production: false,
    appVersion: require('../../package.json').version + '-demo',
    appTitle: "BestLevelSupport by MVIP",
    appLogoPath : "assets\\Wortmarkekomplett.svg",
    appFavicon : "assets\\faviconente.ico",
    appLogoFavicon : "assets\\favicondemo.ico",
    appFavicongif :"assets\\favicon1.gif",
    pCC_loginissue_Frontend: "https://help.simply-supported.de",
    tCCTicketFrontend: "https://support.simply-supported.de",
    tCCTicketServer: "https://ticket.simply-supported.de",
    TicketAuthorisation: "https://authorisation.simply-supported.de"

};
